import React, { FC } from 'react';
import AgeCategorySelector from '../../shared/common/AgeCategorySelector';
import LoanFormatDropDown from '../../shared/navigation/LoanFormatDropDown';
import SubNavigationLayout from '../../shared/navigation/SubNavigationLayout';
import { LinkContainer } from '../../shared/navigation/NavigationLinksContainer';
import { NavigationLink } from '../../shared/navigation/NavigationLink';
import { useQueryParams } from '../../shared/hooks/useQueryParams';
import { MATERIAL_ICON_ARROW_FORWARD } from '../../shared/common/Button/Icon';
import { useTranslation } from 'react-i18next';
import { useAgeCategorySearchParam } from '../../shared/utils/useAgeCategorySearchParam';

type Props = {
    readonly isSticky: boolean;
};

const CollectionNavigation: FC<Props> = ({ isSticky }) => {
    const { t } = useTranslation();
    const { searchParam: ageCategorySearchParam } = useAgeCategorySearchParam();
    const {
        display: { value: displayQueryParam }
    } = useQueryParams({
        display: 'string'
    });

    const searchParams = new URLSearchParams(ageCategorySearchParam ? { ageCategory: ageCategorySearchParam } : {});
    if (displayQueryParam) {
        searchParams.set('display', displayQueryParam);
    }

    return (
        <SubNavigationLayout
            left={<LoanFormatDropDown showIcons={true} />}
            center={
                <LinkContainer>
                    <li>
                        <NavigationLink
                            to={{
                                pathname: `/collection/complete`,
                                search: searchParams.toString()
                            }}
                        >
                            {t('menu.yourBorrowbox.yourCollection.completeCollection')}
                        </NavigationLink>
                    </li>
                    <li>
                        <NavigationLink
                            to={{
                                pathname: `/collection/newly-added`,
                                search: searchParams.toString()
                            }}
                        >
                            {t('menu.yourBorrowbox.yourCollection.newlyAdded')}
                        </NavigationLink>
                    </li>
                    <li>
                        <NavigationLink
                            to={{
                                pathname: `/collection/by-genre`,
                                search: searchParams.toString()
                            }}
                        >
                            {t('menu.yourBorrowbox.yourCollection.byGenre')}
                        </NavigationLink>
                    </li>
                    <li style={{ position: 'relative' }}>
                        <NavigationLink to={'/assistant/reserves'}>
                            {t('menu.yourBorrowbox.yourCollection.orderingAssistant')}{' '}
                            <span className="material-icons">{MATERIAL_ICON_ARROW_FORWARD}</span>
                        </NavigationLink>
                    </li>
                </LinkContainer>
            }
            right={!isSticky ? <AgeCategorySelector /> : null}
            isSticky={isSticky}
            width="20"
        />
    );
};

export default CollectionNavigation;
